var map = {
	"./banner_20241101_lottecard.png": 1098,
	"./banner_20241105_hanchon.png": 1723,
	"./banner_20241105_yaorder.png": 3210,
	"./banner_20241121_bulmakyeolsam.png": 9228,
	"./banner_20241125_songchugamagol.png": 3581,
	"./banner_ad.png": 7433,
	"./banner_jp.png": 1936,
	"./banner_jp_lg.png": 3030,
	"./banner_jp_sm.png": 4661,
	"./banner_lg.png": 8105,
	"./banner_sm.png": 6230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;